const REACT_APP_SBMA_ASSETS_API_ENDPOINT = process.env.REACT_APP_SBMA_ASSETS_API_ENDPOINT;
const PORT_BASE_URL = REACT_APP_SBMA_ASSETS_API_ENDPOINT + "/api/v1/port";

export default {

    GET_LIST_PORT_WITH_PAGINATION:                                  PORT_BASE_URL  + "/list",
    VIEW_PORT:                                                      PORT_BASE_URL  + "/view",
    CREATE_PORT:                                                    PORT_BASE_URL  + "/create",
    SEARCH_PORT:                                                    PORT_BASE_URL  + "/search",
    GET_PORT_TYPE_LIST:                                             PORT_BASE_URL  + "/type/list",
    UPDATE_PORT:                                                    PORT_BASE_URL  + "/update", 
    UPDATE_PORT_STATUS:                                             PORT_BASE_URL  + "/update/status",
    FILTER_PORT:                                                    PORT_BASE_URL  + "/filter/list",  
}